import { ReactElement } from 'react'
import { toNumber } from 'lodash-es'
import { Stack } from '@mui/material'
import { ImmutableVector3 } from '@modugen/ui-toolkit'
import { Select } from '@ui/forms'
import { useModelStore } from '@editorStores'
import { useStoreSubscription } from '@editorHooks'
import WallStartEndFields from '../../../../../WallForm/components/WallStartEndFields'
import { applyFormValuesToWall } from '../../../../../WallFormV2/components/WallFormSceneMarker/utils'
import WallLengthAdjustmentFields from '../WallLengthAdjustmentFields'

interface Props {
  wall: ShapeObject
  isPlacementEditable: boolean
  handleReset?: () => void
}

const FormFields = ({ wall, isPlacementEditable, handleReset }: Props): ReactElement => {
  const updateWall = useModelStore(state => state.updateWall)

  useStoreSubscription({
    writeCallback: ({ start, end, placement }) => {
      const newWall = applyFormValuesToWall(
        wall,
        new ImmutableVector3(toNumber(start.x), toNumber(start.y), toNumber(start.z)),
        new ImmutableVector3(toNumber(end.x), toNumber(end.y), toNumber(end.z)),
        placement,
      )

      updateWall(newWall)
    },
    compareValues: true,
  })

  return (
    <Stack spacing={1} border={1} p={1} borderColor="grey.200" borderRadius={1}>
      <WallStartEndFields zDisabled={true} />

      <Select
        label="Platzierung auswählen"
        name="placement"
        options={[
          {
            value: 'External',
            label: 'Extern',
          },
          {
            value: 'Internal',
            label: 'Intern',
          },
        ]}
        disabled={!isPlacementEditable}
        data-cy="select-placement"
      />

      <WallLengthAdjustmentFields handleReset={handleReset} />
    </Stack>
  )
}

export default FormFields
